import { useMemo } from 'react';
import { matchRoutes, useLocation } from 'react-router';

import { routes } from '@sternum/web/config/routes';

type RouteObject = { [route: string]: string | RouteObject };

function extractAllRoutePaths(route: RouteObject): string[] {
  return Object.entries(route)
    .flatMap(([key, pathOrNestedRoute]) => {
      if (typeof pathOrNestedRoute === 'string' && key === 'absolute') {
        return pathOrNestedRoute;
      }

      if (typeof pathOrNestedRoute === 'object') {
        return extractAllRoutePaths(pathOrNestedRoute);
      }

      return '';
    })
    .filter(Boolean);
}

const allRoutePaths = Object.values(routes)
  .flatMap((route) => extractAllRoutePaths(route))
  .map((path) => ({ path }));

export function useCurrentRoutePattern() {
  const location = useLocation();
  const matches = useMemo(() => matchRoutes(allRoutePaths, location), [location]);

  return matches?.[0]?.route.path;
}
